import LegalDocumentView from '../components/LegalDocumentView';
import SiteLayout from '../components/SiteLayout';
import { useLocale } from '../hooks/useLocale';

export default function PrivacyPage() {
  const { locale, t } = useLocale();

  return (
    <SiteLayout t={t}>
      <LegalDocumentView docKey="privacy" locale={locale} labels={t.legalUi.privacy} />
    </SiteLayout>
  );
}
